module.exports = __webpack_public_path__ + "img/ICON_FuelGauge_Empty_Colors.aebd5fdc.svg";